import { connect } from 'react-redux'

import { ShippingIcon } from 'components/icons'
import { getShippingAddress, getShippingConsolidation } from 'registry/reducers'

import { useFeature } from 'flagged'
import SetupGoal from './setup-goal'

function getText(state) {
  const address = getShippingAddress(state)
  const consolidation = getShippingConsolidation(state)
  const enrolledInBundledShipping =
    consolidation?.consolidationChoice === 'rolling'

  if (!(address && address.city && address.state && address.zip))
    return 'Where do we ship your gifts?'

  if (address.needsConfirmation) return 'Confirm your shipping address.'

  const shippingVerb = enrolledInBundledShipping
    ? 'bundled and shipped'
    : 'shipped'

  const shippingLocation =
    address.city.length <= 20 ? address.city : address.zip

  return (
    <>
      Your Babylist Shop gifts will be {shippingVerb} to {shippingLocation}.
    </>
  )
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <ShippingIcon alternate={ownProps.alternateIcon} />,
    text: getText(state),
  }
}

export default connect(mapStateToProps)(SetupGoal)
